import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import EmailTemplates from 'containers/Email'
import Inbox from 'containers/Inbox'
import Notifications from 'containers/Notifications'
import SMSTemplates from 'containers/SMS'
import BulkUploadMapper from './ContactsPage/BulkUploadMapper'
import AddOrEditContactPage from './AddOrEditContactPage'
import SMSPage from './SMSPage'
import ScheduledEmailsPage from './ScheduledEmailsPage'
import AddOrEditGroupPage from './AddOrEditGroupPage'
import CreateOrEditTemplatePage from './CreateOrEditTemplatePage'
import AddOrEditTaskPage from './AddOrEditTaskPage'
import AccountSettingsPage from './AccountSettingsPage'
import AddOrEditFormPage from './AddOrEditFormPage'
import AddOrEditCampaignPage from './AddOrEditCampaignPage'
import Pricing from './Pricing'
import NotFound from './NotFound'
import ManagePhones from './ManagePhones'
import S3Manager from './S3Manager'
import UserPage from './Users/User'
import ListView from './ListView'
import Testing from './Testing'
import AddOrEditKnowledgePage from './AddOrEditKnowledgePage'
import ManageCompliance from './ManageCompliance'
import Onboarding from './OnboardingNew'
import CustomAuth from './CustomAuth'
// Import routes explicitly
import {
  contact,
  task,
  group,
  form,
  knowledge,
  campaign,
  urls,
  template,
} from './routes'

export default class ConnectedSwitch extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Inbox} />
        <Route exact path="/knowledge/:id" component={AddOrEditKnowledgePage} />
        <Route exact path="/contacts/new" component={AddOrEditContactPage} />
        <Route exact path="/contacts/upload" component={BulkUploadMapper} />
        <Route
          exact
          path="/contacts/:contactID"
          component={AddOrEditContactPage}
        />
        <Route
          exact
          path="/templates/:templateType"
          component={CreateOrEditTemplatePage}
        />
        <Route path="/email/templates" component={EmailTemplates} />
        <Route path="/sms/templates" component={SMSTemplates} />

        <Route
          exact
          path="/templates/:templateType/:templateId"
          component={CreateOrEditTemplatePage}
        />
        <Route exact path="/sms/" component={SMSPage} />
        <Route exact path="/sms/:contactID" component={SMSPage} />
        <Route exact path="/scheduled-emails" component={ScheduledEmailsPage} />
        <Route
          exact
          path="/contactgroups/:groupID"
          component={AddOrEditGroupPage}
        />
        <Route exact path="/tasks/:taskID" component={AddOrEditTaskPage} />
        <Route exact path="/accountsettings" component={AccountSettingsPage} />
        <Route exact path="/forms/:formType" component={AddOrEditFormPage} />
        <Route
          exact
          path="/forms/:formType/:formID"
          component={AddOrEditFormPage}
        />
        <Route
          exact
          path="/campaigns/:campaignID"
          component={AddOrEditCampaignPage}
        />
        <Route exact path="/inbox" component={Inbox} />
        <Route exact path="/managephones" component={ManagePhones} />
        <Route exact path="/files" component={S3Manager} />
        <Route exact path="/files/:filePath+" component={S3Manager} />
        <Route exact path="/pricing" component={Pricing} />
        <Route exact path="/user/:username" component={UserPage} />
        <Route exact path="/testing" component={Testing} />
        <Route exact path="/managecompliance" component={ManageCompliance} />
        <Route exact path="/notifications" component={Notifications} />
        <Route exact path="/onboarding" component={Onboarding} />
        <Route exact path="/userinvitation" render={(props) => <CustomAuth {...props} alreadySignedIn />} />
        <Route exact path="/createaccount" render={(props) => <CustomAuth {...props} alreadySignedIn />} />
        {/* Explicitly define each list view route */}
        <Route
          exact
          path={contact.path}
          render={props => <ListView {...props} {...contact} />}
        />
        <Route
          exact
          path={task.path}
          render={props => <ListView {...props} {...task} />}
        />
        <Route
          exact
          path={group.path}
          render={props => <ListView {...props} {...group} />}
        />
        <Route
          exact
          path={form.path}
          render={props => <ListView {...props} {...form} />}
        />
        <Route
          exact
          path={knowledge.path}
          render={props => <ListView {...props} {...knowledge} />}
        />
        <Route
          exact
          path={campaign.path}
          render={props => <ListView {...props} {...campaign} />}
        />
        <Route
          exact
          path={urls.path}
          render={props => <ListView {...props} {...urls} />}
        />
        <Route
          exact
          path={template.path}
          render={props => <ListView {...props} {...template} />}
        />
        <Route component={NotFound} />
      </Switch>
    )
  }
}
